import React from 'react';
import Subnavigation from '@interness/web-core/src/components/structure/Subnavigation/Subnavigation';
import { useBrandsMenu } from '../../../hooks/useBrandsMenu';
import { jsx as ___EmotionJSX } from "@emotion/react";
const BrandsSubnavigation = props => {
  const {
    menu,
    overview,
    typeInfo
  } = useBrandsMenu(props.type);
  return ___EmotionJSX(Subnavigation, {
    menu: menu,
    overview: overview,
    menuTitle: `Markenwelt: ${typeInfo.display_name}`
  });
};
export default BrandsSubnavigation;